import { combineReducers } from 'redux-immutable'
import leaveGenerationGetReducer from './leave-generation-get-reducer'
import leaveGenerationEditReducer from './leave-generation-edit-reducer'
import leaveGenerationImportReducer from './leave-generation-import-reducer'
import leaveGenerationExportReducer from './leave-generation-export-reducer'
import leaveGenerationUserExportReducer from './leave-generation-user-export-reducer'

export default combineReducers({
  leaveGenerationGet: leaveGenerationGetReducer,
  leaveGenerationEdit: leaveGenerationEditReducer,
  leaveGenerationImport: leaveGenerationImportReducer,
  leaveGenerationExport: leaveGenerationExportReducer,
  leaveGenerationUserExport: leaveGenerationUserExportReducer,
})



// WEBPACK FOOTER //
// ./src/reducers/leave-generation/index.js